import { createPortalSlot } from '@/components/PortalSlot';

export const ProjectSidebarSlot = createPortalSlot();
